import React from 'react';
import CustomCandlesLogo from '../components/CustomCandlesLogo';

const LogoTest: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-100 dark:bg-gray-900 p-8">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-3xl font-bold text-center mb-8 text-gray-900 dark:text-white">
          Logo Preview
        </h1>
        
        {/* Different sizes */}
        <div className="space-y-8">
          <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-md">
            <h2 className="text-xl font-semibold mb-4 text-gray-900 dark:text-white">Small Size (Mobile)</h2>
            <div className="flex items-center justify-center">
              <CustomCandlesLogo size="sm" />
            </div>
          </div>
          
          <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-md">
            <h2 className="text-xl font-semibold mb-4 text-gray-900 dark:text-white">Medium Size (Desktop)</h2>
            <div className="flex items-center justify-center">
              <CustomCandlesLogo size="md" />
            </div>
          </div>
          
          <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-md">
            <h2 className="text-xl font-semibold mb-4 text-gray-900 dark:text-white">Large Size</h2>
            <div className="flex items-center justify-center">
              <CustomCandlesLogo size="lg" />
            </div>
          </div>
        </div>
        
        {/* Dark mode test */}
        <div className="mt-8 bg-gray-800 p-6 rounded-lg shadow-md">
          <h2 className="text-xl font-semibold mb-4 text-white">Dark Mode</h2>
          <div className="flex items-center justify-center">
            <CustomCandlesLogo size="md" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default LogoTest;

